import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=d99b404e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=d99b404e&prod&lang=css"
import style1 from "./detail.vue?vue&type=style&index=1&id=d99b404e&prod&lang=scss&scoped=true"
import style2 from "./detail.vue?vue&type=style&index=2&id=d99b404e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99b404e",
  null
  
)

export default component.exports